<script>
    export let w
    export let rotation
    export let shape = 0
    export let o = false;
    
    let rotations = [90,180,-90,-180]
    function getRandomRotation(){
        return Math.floor(Math.random())
    }
    </script>
        
    {#if shape == 0}
    
    <svg width="{w}" height="{w}" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg"  >
        <g style="transform-origin:center" transform="rotate({rotations[rotation]})">
        <rect width="100" height="100" fill="black" opacity="{o ? Math.random() : 1}"/>
        <path d="M0 0H100V100L0 0Z" fill="black" opacity="{o ? Math.random() : 1}"/>
        </g>
    </svg>
    
    {/if}
    
    {#if shape == 1}
    <svg width="{w}" height="{w}" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g style="transform-origin:center" transform="rotate({rotations[rotation]})">
    <rect width="100" height="100" fill="black" opacity="{o ? Math.random() : 1}"/>
    <path d="M100 100C44.7715 100 0 55.2285 0 0H100V100Z" fill="white" opacity="{o ? Math.random() : 1}"/>
        </g>
    </svg>
    
    
    {/if}
    
    {#if shape==2}
    <svg width="{w}" height="{w}" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g style="transform-origin:center" transform="rotate({rotations[rotation]})">
    
    <path d="M-8.74228e-06 200C-55.2285 200 -100 155.228 -100 100C-100 44.7715 -55.2285 -6.78525e-06 0 -4.37114e-06C55.2285 -1.95703e-06 100 44.7715 100 100C100 155.228 55.2285 200 -8.74228e-06 200ZM-1.20955e-06 27.6714C-39.946 27.6714 -72.3286 60.054 -72.3286 100C-72.3286 139.946 -39.946 172.329 -7.53272e-06 172.329C39.946 172.329 72.3286 139.946 72.3286 100C72.3286 60.054 39.946 27.6714 -1.20955e-06 27.6714Z" fill="black"/>
    </g>
    
    </svg>
    
    
    
    
    {/if}
    
    